module.exports = __webpack_public_path__ + "img/arrow-right-white.6f7e1d25.svg";